import { jsx } from 'react/jsx-runtime';
import { isString } from '@fabric-app/utils/guards/index';
import { forwardRef } from 'react';

const CompatLink = /* @__PURE__ */ forwardRef(({ href, children, ...props }, ref) => {
  const url = isString(href) ? href : new URL(href.pathname ?? "", href.hostname ?? void 0).toString();
  return /* @__PURE__ */ jsx("a", {
    ref,
    href: url,
    ...props,
    children
  });
});
CompatLink.displayName = "CompatLink";

export { CompatLink };
//# sourceMappingURL=Link.js.map
